import { CheckCircle2 } from 'lucide-react';

const SIZES = {
  sm: 'text-[11px] px-2 py-0.5 gap-1',
  md: 'text-sm px-3 py-1 gap-1.5',
  lg: 'text-lg px-4 py-1.5 gap-2',
};

const TONES = {
  light: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  dark: 'bg-emerald-400/15 text-emerald-300 border-emerald-300/30',
};

export const BoughtBadge = ({ testId, size = 'sm', tone = 'light' }) => (
  <span
    className={`inline-flex items-center rounded-full border font-bold whitespace-nowrap ${SIZES[size]} ${TONES[tone]}`}
    data-testid={testId}
  >
    <CheckCircle2 className={size === 'lg' ? 'w-5 h-5' : 'w-3.5 h-3.5'} />
    Bought
  </span>
);
